import { TableSkeleton } from "@hiya/ui";
import { CenteredMessage } from "./CenteredMessage";

export function DetailLoadingState() {
  return (
    <div className="p-6">
      <TableSkeleton columns={1} rows={4} />
    </div>
  );
}

export function DetailErrorState({ message }: { message: string }) {
  return <CenteredMessage message={message} />;
}

export function DetailNotFoundState({ message }: { message: string }) {
  return <CenteredMessage message={message} />;
}
